import { Column } from '../types';
import TableCell from '@mui/material/TableCell';
import {
  ColumnIds,
  ContactRegistrationStatusValues,
  PlayerRegistrationStatusValues,
} from '../constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faForkKnife } from '@fortawesome/pro-regular-svg-icons';
import { getRegistrationStatusLabel } from '../helpers/registrationStatusMap';
import { hasValue } from '@r-and-a-shared-ui/utils';

import styles from '../DataGridTable.module.scss';

const getRegistrationStatusClass = (status: string) => {
  switch (status) {
    case ContactRegistrationStatusValues.Pending:
    case ContactRegistrationStatusValues.Invited:
    case ContactRegistrationStatusValues.MoreInfoRequested:
    case PlayerRegistrationStatusValues.PreRegistrationComplete:
      return styles.pending;
    case ContactRegistrationStatusValues.Approved:
    case PlayerRegistrationStatusValues.Registered:
      return styles.approved;
    case ContactRegistrationStatusValues.Cancelled:
    case PlayerRegistrationStatusValues.NotRegistered:
      return styles.cancelled;
    default:
      return '';
  }
};

const RegistrationStatusCell = ({ status }: { status: string }) => (
  <span
    className={`${styles.statusCell} ${getRegistrationStatusClass(status)}`}
  >
    {status}
  </span>
);

type DataGridTableCellProps = {
  row: any;
  col: Column;
};

export const DataGridTableCell = ({ row, col }: DataGridTableCellProps) => {
  const renderValue = () => {
    switch (col.id) {
      case ColumnIds.ContactImage:
        return hasValue(row[col.id]) ? (
          <img src={row[col.id]} alt="" className={styles.contactImage} />
        ) : null;
      case ColumnIds.AccreditationDocument:
        return typeof row[col.id] === 'string' && row[col.id] ? (
          <FontAwesomeIcon icon={faFilePdf} className={styles.pdfIcon} />
        ) : null;
      case ColumnIds.RegistrationStatus:
        return (
          <RegistrationStatusCell
            status={getRegistrationStatusLabel(row[col.id])}
          />
        );
      case ColumnIds.NominatedForDinner:
        return typeof row[col.id] === 'boolean' && row[col.id] === true ? (
          <FontAwesomeIcon
            icon={faForkKnife}
            className={styles.forkKnifeIcon}
          />
        ) : null;
      default:
        return row[col.id];
    }
  };

  return <TableCell align={col.alignment}>{renderValue()}</TableCell>;
};
